import { useFormContext, Controller } from "react-hook-form";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Iconify from "../../../../reusable-components/iconify";
import { formStyle } from '../TransitionStyles';
import { validateDEA } from '../ValidateFunctions'

FormDEAField.propTypes = {
  fieldName: PropTypes.string,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  fieldAttributes: PropTypes.object,
}

export default function FormDEAField({ fieldName, focusedField, setFocusedField, fieldAttributes }) {
  const { control } = useFormContext();
  const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);

  return <Controller
    name={fieldName}
    control={control}
    rules={{
      validate: value => validateDEA(value) 
    }}
    render={({ field, fieldState }) => (
      <TextField
        inputRef={field.ref}
        key={field.id}
        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }}
        onFocus={() => setFocusedField(fieldName)}
        inputProps={{
          onBlur: () => setFocusedField(null),
        }}
        fullWidth
        size="small"
        type="text"
        disabled={!fieldAttributes.isEditable || isCanceled}
        value={field.value ?? ''}
        error={!!fieldState.error}
        onChange={(e) => {
          field.onChange(e.target.value.trim())
        }}
        autoComplete="off"
        helperText={fieldState.error?.message}
        sx={formStyle}
        InputProps={{
          endAdornment: (
            field.value && focusedField === fieldName ? (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    field.onChange('');
                  }}
                  edge="end"
                  tabIndex={-1}
                >
                  <Iconify icon="eva:close-outline" />
                </IconButton>
              </InputAdornment>
            ) : null
          ),
        }}
      />
    )}
  />
}